/**
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:51:05
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-19 14:41:32
 * @FilePath: src/utils/auth.js
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
import Cookies from 'js-cookie'
import store from '../store'
let TokenKey = store?.state?.user?.sysConfig?.accessTokenCookieName
// 导入配置文件
// import config from '@/config'F
export function getToken() {
  if (!TokenKey) {
    TokenKey = store.state.user.sysConfig.accessTokenCookieName
  }
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  if (!TokenKey) {
    TokenKey = store.state.user.sysConfig.accessTokenCookieName
  }
  if (!getToken()) {
    return Cookies.set(TokenKey, token)
  }
}

export function setUUCFlag(flag) {
  return Cookies.set('uuc', flag)
}

export function getUUCFlag(flag) {
  return Cookies.get('uuc')
}

export function removeToken() {
  const hostNameSplit = window.location.hostname.split('.')
  const domain = '.' + hostNameSplit[hostNameSplit.length - 2] + '.' + hostNameSplit[hostNameSplit.length - 1]
  localStorage.removeItem('eiipUserInfo')
  Cookies.set('eiipUserInfo', '', { expires: -1 })
  Cookies.set(store?.state?.user?.sysConfig?.accessTokenCookieName, '', { expires: -1 })
  Cookies.set(store?.state?.user?.sysConfig?.refreshTokenCookieName, '', { expires: -1 })
  Cookies.set(store?.state?.user?.sysConfig?.accessTokenCookieName, '', { domain: domain, expires: -1 })
  Cookies.set(store?.state?.user?.sysConfig?.refreshTokenCookieName, '', { domain: domain, expires: -1 })
  return
}

export function removeDominCookie() {
  Cookies.remove(TokenKey)
}

export function checkPermissions(key) {
  if (Array.isArray(store.getters.allPermissions)) {
    return store.getters.allPermissions?.includes(key)
  }
}
